import _ from 'lodash'
import uuid from 'uuid/v4'
import MediaUploader from './MediaUploader'
import ThumbnailGenerator from './ThumbnailGenerator'
import dataUrlToBlob from '@/utils/dataUrlToBlob'
import { getBlobFromFileUrl } from '@/utils/fileUtils'

class VideoService {
  constructor() {
    this.uploader = new MediaUploader()
  }

  async generateThumbnail(video) {
    if (this.thumbnailUrl) {
      return this.thumbnailUrl
    }

    const generator = new ThumbnailGenerator(video)
    this.thumbnailUrl = await generator.asDataUrl()
    return this.thumbnailUrl
  }

  async upload(video, { dirname, type }) {
    dirname = this._generateUploadingPath(dirname)
    const videoKey = await this._uploadVideo(video, dirname, type)
    const thumbnailKey = await this._uploadThumbnail(video, dirname)
    return { videoKey, thumbnailKey }
  }

  _generateUploadingPath(dirname) {
    const serial = uuid()
    return _.compact([dirname, serial.slice(0, 2), serial]).join('/')
  }

  async _uploadVideo(video, dirname, type) {
    const file = video instanceof File ? video : await getBlobFromFileUrl(video)
    const key = `${dirname}/video.${type}`
    await this.uploader.upload({ file, key })
    return key
  }

  async _uploadThumbnail(video, dirname) {
    const dataUrl = await this.generateThumbnail(video)
    const file = dataUrlToBlob(dataUrl)
    const key = `${dirname}/thumbnail.png`
    await this.uploader.upload({ file, key })
    return key
  }

  download(url, onSuccess, onFail) {
    if (window.TigersPlugin == null) {
      window.open(url, '_blank')
    } else {
      window.TigersPlugin.downloadVideo(url, onSuccess, onFail)
    }
  }
}

export default VideoService
